import type { ChatMessage } from "@lib/agent/types";
import Icon from "@lib/common/components/Icon/Icon";
import { Alert, Stack } from "@mantine/core";

export default function ErrorChatMessage({ message }: { message: ChatMessage }) {
  return (
    <Stack flex={1} w="100%">
      <Alert color="red" variant="light" icon={<Icon name="circle-exclamation" />} mb="md">
        {message.content}
      </Alert>
    </Stack>
  );
}
